import { useState } from "react";
import { TextField } from "@mui/material";

function GenericNumberField(props: any) {
  const { value, onChange, decimals = 2, ...rest } = props;

  const [fieldValue, setFieldValue] = useState(
    value ? value.toString().replace(".", ",") : ""
  );

  const formatNumber = (value: string): number => {
    if (typeof value !== "string") return value;

    const number = parseFloat(value.replace(",", "."));

    return parseFloat(number.toFixed(decimals));
  };

  const handleChange = (event: any) => {
    const value = event.target.value.startsWith(",")
      ? "0" + event.target.value
      : event.target.value;

    const decimalNumberRgx = new RegExp(
      `^\\d+`.concat(decimals && decimals > 0 ? `(\.\\d{0,${decimals}})?$` : "$")
    );

    if (value.match(decimalNumberRgx)) {
      const fieldValue =
        value.length > 1 && formatNumber(value) >= 1
          ? value.replace(/^0+/, "")
          : value;
      setFieldValue(/^0+$/.test(fieldValue) ? 0 : fieldValue);
      onChange(formatNumber(value));
    } else if (value.length === 0) {
      setFieldValue("");
      onChange(undefined);
    }
  };

  return (
    <TextField
      value={fieldValue}
      onChange={handleChange}
      fullWidth
      size="small"
      variant="outlined"
      {...rest}
    />
  );
}

export default GenericNumberField;
